import React from "react";

interface CustomModalProps {
  image: string; // URL or import of the image
  paragraph: string;
  onClose: () => void;
  imgstyle?: any;
}

const CustomModal: React.FC<CustomModalProps> = ({
  image,
  paragraph,
  onClose,
  imgstyle,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="relative bg-[#25405A] rounded-[20px] w-[90vw] max-w-md p-6 flex flex-col items-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white text-3xl font-bold focus:outline-none"
          aria-label="Close modal"
        >
          &times;
        </button>
        <img
          src={image}
          alt="Modal visual"
          className={`rounded-xl w-full max-w-xs mb-6 mt-7 object-contain ${imgstyle} `}
        />
        <p className="text-white text-center text-lg font-medium leading-7">
          {paragraph}
        </p>
      </div>
    </div>
  );
};

export default CustomModal;
